export class DocumentTypeAliasesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentTypeAliases(params) {
    return this.#http.get('/api/document-type-aliases', { params });
  }

  async createDocumentTypeAlias(body) {
    return this.#http.post('/api/document-type-aliases', body);
  }

  async updateDocumentTypeAlias(body) {
    return this.#http.put(`/api/document-type-aliases/${body.id}`, body);
  }

  async deleteDocumentTypeAlias({ id }) {
    return this.#http.delete(`/api/document-type-aliases/${id}`);
  }
}
